<template>
	<div>
		<div class="commonBox">
			<div class="headerBox">
				<a @click="jump" style="width: 16.6875rem; height: 3.5625rem;">
					<img src="../assets/images/logo.png" style="width: 100%; height: 100%; object-fit: contain;" />
				</a> 
				<div class="rightbox">
					<!-- <div class="inputBox">
						<div style="width: 1.125rem; height: 1.125rem;display: flex;align-items: center;justify-content: center;">
							<img  src="../assets/images/icon-search.png"style="width: 100%; height: 100%; object-fit: contain;"/>
						</div>
						<input type="text" placeholder="请输入关键词">
					</div>
					<span>搜索</span> -->
				</div>
			</div>
			<div class="navbox">
				<div class="navItem" v-for="(item,index) in navlist" :key="index" @click="path(item)" @mouseover="handle(index)" @mouseout="current1=''">
					<a :class="{active:current==index}">{{item.title}}</a>
					<div class="secondbox" v-show="current1==index" >
						<div v-for="(item1,index1) in item.content" :key="index1" @click.stop="path(item1,index1)">{{item1.title}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="smallBox">
			<div class="smallHeader">
				<img  src="../assets/images/logo.png" width="189px" height="40px" @click="jump"/>
				<img src="../assets/images/phone/nav_icon.svg" alt="" width="30px" height="24px" v-if="showcode==false" @click="showcode=true"/>
				<img src="../assets/images/phone/close_icon.svg" alt="" width="30px" height="24px" v-if="showcode==true" @click="showcode=false"/>
			</div>
			
			<div class="smallNav" v-if="showcode">
				<div v-for="(item,index) in navlist" :key="index" class="smallNavItem" @click="path(item)">
					<div class="smallNavItembigTitle">{{item.title}}</div>
					<div >
						<div v-for="(item1,index1) in item.content" class="smallsubNavItem" @click.stop="path(item1,index1)">{{item1.title}}</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {GetDepart} from '@/api/api'
	export default{
		props:['current'],
		data(){
			return{
				showcode:false,
				flag:false,
				current1:'',
				navlist:[
					{title:'关于我们',url:'/'},
					{title:'特色功能中心',url:'/artile',current:1,guid:'69e65621-a371-4f11-bac3-a01698dad7d9',
						content:[
							{title:'健康体检中心',url:'/artile',current:1,guid:'69e65621-a371-4f11-bac3-a01698dad7d9'},
							{title:'医学影像中心',url:'/artile',current:1,guid:'2e6d02ac-13f8-474a-ab24-7077e9565e81'},
							{title:'精准检验中心',url:'/artile',current:1,guid:'6ad18ba6-5f27-4ad0-87b9-6312bcbed6fe'},
							{title:'慢病管理中心',url:'/artile',current:1,guid:'3b512472-50d8-4550-af82-cac14f1e3ad5'},
							{title:'康复理疗中心',url:'/artile',current:1,guid:'086b99a6-a98d-4372-a8f0-07df2303d617'},
							{title:'高压氧疗中心',url:'/artile',current:1,guid:'04e1cbcc-9fc1-42c6-a43d-4ad37e3da687'},
							{title:'消化内镜中心',url:'/artile',current:1,guid:'459898df-aebd-4b1f-b4d9-c6168737a47a'},
						],
					},
					{title:'专家团队',url:'/DoctorTeam',
						content:[
							// {title:'科室介绍',url:'/ExpertTeam'},
							{title:'专家介绍',url:'/DoctorTeam'},
						],
					},
					{title:'生态岛环境',url:'/artile',current:3,guid:'8dca3b51-f33d-4498-b620-4e775d1fb87c',
						content:[
							{title:'长寿岛',url:'/artile',current:3,guid:'8dca3b51-f33d-4498-b620-4e775d1fb87c'},
							{title:'候鸟天堂',url:'/artile',current:3,guid:'b1830963-a24f-450a-a3ae-c86bfb883976'},
							{title:'湿地公园',url:'/artile',current:3,guid:'c8ce7882-afbb-4479-b9ba-a38d865cc19a'},
							{title:'天然氧吧',url:'/artile',current:3,guid:'b337ec1b-1657-4a1d-b437-d22e825b73d1'},
						],
					},
					{title:'新闻资讯',url:'/news'},
					// {title:'健康体检',url:'/HealthIntro',
					// 	content:[
					// 		{title:'体检介绍',url:'/HealthIntro'},
					// 		{title:'常规体检',url:'/PhysicalExamination'},
					// 		{title:'VIP体检',url:'/vipPE'},
					// 	],
					// },
					
					// {title:'康复疗养',url:'/artile',current:5,guid:'5699a212-98a4-4358-b28f-3b0f3a1ff160',
					// 	content:[
					// 		{title:'运动康复',url:'/artile',current:5,guid:'5699a212-98a4-4358-b28f-3b0f3a1ff160'},
					// 		{title:'中医理疗',url:'/artile',current:5,guid:'81b6eab0-a251-46ae-9e40-735894de6514'},
					// 		{title:'音乐疗法',url:'/artile',current:5,guid:'26c48817-69d0-44b5-9311-07cde32005ac'},
					// 	],
					// },
					// {title:'特色服务',url:'/artile',current:6,guid:'ff5835b4-2252-4b02-9b01-fa4ffa8b624f',
					// 	content:[
					// 		{title:'基因检测',url:'/artile',current:6,guid:'ff5835b4-2252-4b02-9b01-fa4ffa8b624f'},
					// 		{title:'DNA甲基化检测',url:'/artile',current:6,guid:'b4dbef1a-b54c-4bec-96a3-e0b6137376ae'},
					// 	],
					// },
					// {title:'在线预约',url:'/onlineYY'},
				],
				drpartCurrent:0,
			}
		},
		created() {
			// window.addEventListener('scroll', this.handleScroll, true),
			// this.GetData();
		},
		methods:{
			jump(){
				this.$router.push('/');
			},
			clickbtn(data) {
				this.path(data.url, data.index);
				if(data.url == '/artile') location.reload()
				
			},
			path(item,index){
				this.showcode=false
				console.log(item,'itemitemitemitemitem')
				if(item.url.indexOf('artile') >= 0) {
					this.$router.push({ 
						path: '/artile', 
						query: { current: item.current, guid: item.guid } ,
					})
					location.reload()
				} else {
				   this.$router.push(item.url)
				}
				this.drpartCurrent=index
				this.$emit('clickbtn',this.drpartCurrent)
			},
			handle(index){
				this.current1=index
			},

			handleScroll(){
				this.$nextTick(()=>{
					var top = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
					console.log(document.body.scrollTop)
					if(top >822){
						this.flag=true
					}else{
						this.flag=false
					}
				})
			},
			pathTop(){
				window.scrollTo(0,0);
			},
			GetData(){
				GetDepart({status:1}).then(res => {
					res.data.data.rows.forEach((item,index)=>{
						this.navlist[3].content.push({
							title:item.deptName,
							url:'/expertIntroducton'
						})
					})
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.headerBox{
		margin:0 auto;
		min-width: $commoneWidth;
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding:1.75rem 5.625rem 1.875rem 3.4375rem;    
		box-sizing: border-box;
		border-bottom:1px solid $fintColor;
		.rightbox{
			display: flex;
			align-items: center;
			.inputBox{
				width:18.75rem;
				height:2.875rem;
				border:0.125rem solid $baseColor;
				border-radius:0.5rem 0 0 0.5rem;
				display: flex;
				align-items: center;
				padding-left:0.75rem;
				box-sizing: border-box;
				justify-content: center;
				input{
					width: 18.125rem;
					height: 2rem;
					border: none;
					background: transparent; /* 背景透明 */
					outline: none; /* 去掉聚焦时的轮廓 */
					padding-left:0.5rem;
					font-size: 1rem;
				}
				input::placeholder {
				  color: #999; /* 设置占位符文本颜色 */
				}
			}
			span{
				display:inline-block ;
				width: 5.8125rem;
				height: 2.875rem;
				line-height: 2.875rem;
				background-color: $baseColor;
				color:#fff;
				text-align: center;
				border-radius: 0 0.5rem 0.5rem 0;
			}
		}
	}
	.navbox{
		min-width: $commoneWidth;
		margin: 0 auto;
		color:#fff;
		color:$fintColor;
		display: flex;
		font-size: 1.375rem;
		padding:0 3.4375rem;
		box-sizing: border-box;
		.navItem{
			flex:1;
			text-align: center;
			position: relative;
			padding:1.25rem 0;
			a{
				display: inline-block;
				line-height: 3rem;
				&.active{
					background-color: $baseColor;
					color:#fff;
					width: 10rem;
					border-radius: 0 1.375rem 1.375rem 1.375rem;
				}
			}
			.secondbox{
				cursor: pointer;
				position: absolute;
				top:5.5625rem;
				width: 12rem;
				background: #ffffff;
				color:$fintColor;
				left: 50%;
				margin-left: -4.5625rem;
				padding:0 1.5625rem;
				box-sizing: border-box;
				z-index:999;
				border-radius: 1.375rem;
				div{
					// line-height: 50px;
					display: flex;
					margin-bottom: 1.25rem;
					align-items: center;
					text-align: left;
					&:hover{
						color:$baseColor;
					}
					&:first-child{
						padding-top: 1.25rem;
					}
					// &:last-child{
					// 	padding-bottom: 20px;
					// }
				}
			}
		}
	}
	.righttel{
		position: fixed;
		z-index:999;
		bottom:0.625rem;
		right: 1.4375rem;
		cursor: pointer;
	}
	.imgcode{
		position: absolute;
		bottom:-7.875rem;
		text-align: center;
		z-index:999;
		img{
			width: 7.5rem;
			height: 7.5rem;
		}
	}
	@media screen and (min-width: 769px) {//pc版本
		.smallBox{
			display: none;
		}
	}
	@media screen and (max-width: 768px) {//手机版本
		.commonBox{
			display: none;
		}
		.smallBox{
			position: relative;
			font-size:14px;
			.smallHeader{
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 20px 10px 10px;
				border-bottom: 1px solid $fintColor;
			}
			.smallNav{
				position: absolute;
				top: 61px;
				left: 0;
				width: 100%;
				background-color: #fff;
				z-index: 999;
				max-height: 80vh;
				overflow-y: auto;
				.smallNavItem{
					color:$fintColor;
					background-color: #fff;
					padding: 0 20px;
					.smallNavItembigTitle{
						padding: 10px 0 ;
					}
					.smallsubNavItem{
						padding: 4px 20px;
						cursor: pointer;
						color:$baseColor;
						&:first-child{
							border-top: 1px solid $baseColor;
							animation: fadeIn 0.3s ease-in-out;
						}
						@keyframes fadeIn {
							from {
								opacity: 0;
								transform: translateY(-10px);
							}
							to {
								opacity: 1;
								transform: translateY(0);
							}
						}
					}
				}
			}
		}
		
	}
</style>
